var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTiktokDesktopHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 14,
  viewBox: "0 0 15 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M10.714 0C13.081 0 15 1.89 15 4.22c0 2.565-1.503 4.673-4.267 7.048l-.472.4-.409.355Q7.89 13.713 7.5 13.714q-.429 0-2.76-2.047C1.674 9.127 0 6.927 0 4.22 0 1.89 1.919 0 4.286 0c1.243 0 2.363.522 3.146 1.355l.068.073.068-.073A4.3 4.3 0 0 1 10.594.002zM4.286 1.2C2.577 1.2 1.2 2.556 1.2 4.22c0 2.11 1.252 3.992 4.331 6.545l.48.417q.684.587 1.15.944l.26.194.078.054.19-.135.278-.212q.446-.348 1.08-.895l.445-.386.169-.141c2.93-2.46 4.139-4.313 4.139-6.385 0-1.604-1.28-2.923-2.904-3.015L10.72 1.2l-.093.002a3.1 3.1 0 0 0-2.035.826l-.144.143-.954 1.03-.936-1.024A3.1 3.1 0 0 0 4.286 1.2"
})));
export default SvgTiktokDesktopHeart;